import { render, staticRenderFns } from "./FamousPediaLeftWeb.vue?vue&type=template&id=846a71fe&"
import script from "./FamousPediaLeftWeb.vue?vue&type=script&lang=js&"
export * from "./FamousPediaLeftWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports